import { REGEX_GRADIENT } from 'shared/constants/regex.ts'
import { PagesModule, PagesModuleRouter } from 'shared/ui/tabs-pages'

export const getHeaderBackgroundColor = (
  module: PagesModule,
): string | undefined => {
  const backgroundColor = PagesModuleRouter?.[module]?.newTabs?.backgroundColor
  const moduleColor = PagesModuleRouter?.[module]?.color

  if (!backgroundColor) return moduleColor

  const matches = backgroundColor.match(REGEX_GRADIENT)
  return matches && matches.length > 0
    ? matches[matches.length - 1]
    : moduleColor
}
